/**
 * Exports image item-related design tokens
 */

// Styles for <figcaption> generated by ```gatsby-remark-images``` plugin
export const captionTextKind = 'p/caption';
export const captionMarginTop = 2;